import { computed } from 'vue'
import { format } from 'date-fns'
import { useStorefront } from './storefront'
import { useConfig } from './config'
import { useSlots } from './slots'

export function useCapacities(date = null) {
    const { current } = useSlots()
    const { storefront } = useStorefront()
    const { config } = useConfig()

    const capacities = computed(() => storefront.value?.capacities ?? {})

    const predicate = (date) => {
        if (config.value?.slots) {
            if (current.value?.totalCapacity === Infinity) {
                return true
            }

            if (!Object.keys(capacities.value).length) {
                return true
            }

            const key = format(date, 'yyyy-MM-dd')
            const capacity = capacities.value[key] ?? 0
            return capacity > 0
        }

        return true
    }

    const capacity = computed(() => {
        if (config.value?.slots) {
            if (current.value?.totalCapacity === Infinity) {
                return Infinity
            }

            if (!date.value) {
                return 0
            }

            if (Object.keys(capacities.value).length === 0) {
                return Infinity
            }

            const key = format(date.value, 'yyyy-MM-dd')
            return capacities.value[key] ?? 0
        }

        return Infinity
    })

    return {
        capacities,
        capacity,
        predicate
    }
}